export const isNativeApp = () => {
  if (!window) return;

  return !!window.isRNWebview;
};

export const isAndroid = (_userAgent?: string) => {
  if (typeof window === 'undefined') return false;

  const userAgent = (_userAgent || navigator.userAgent).toLowerCase();
  return /android/i.test(userAgent);
};

export const isIOS = (_userAgent?: string) => {
  if (typeof window === 'undefined') return false;

  const userAgent = (_userAgent || navigator.userAgent).toLowerCase();
  return /iphone|ipad|ipod/i.test(userAgent);
};

export const isMobile = () => {
  const userAgent =
    typeof window !== 'undefined' ? window.navigator.userAgent : '';
  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  return mobileRegex.test(userAgent);
};
